export default "__VITE_ASSET__eb6a4a5d__"